export function redirectToLiqPay({ data, signature }) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = "https://www.liqpay.ua/api/3/checkout";
  form.acceptCharset = "utf-8";

  const i1 = document.createElement("input");
  i1.type = "hidden";
  i1.name = "data";
  i1.value = data;

  const i2 = document.createElement("input");
  i2.type = "hidden";
  i2.name = "signature";
  i2.value = signature;

  form.appendChild(i1);
  form.appendChild(i2);
  document.body.appendChild(form);
  form.submit();
}
